<template>
  <base-section id="all-blogs">
    <base-section-heading
      color="grey lighten-2"
      title="Blogs"
    />

    <v-container>
      <v-row>
        <v-col v-for="card in cards" :key="card._id" cols="12" md="4">
          <single-content :content="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import SingleContent from "@/views/home/page/SingleContent.vue";

@Component({
  name: "AllBlogs",
  components: { SingleContent },
})
export default class AllBlogs extends Vue {
  cards = [];
  async mounted() {
    this.cards = await doGet("/api/o/screen/grid/7/pages");
  }
}
</script>
